// 9fbef606107a605d69c0edbcd8029e5d
import { MERGE_ACCOUNT_EMAIL_ADDRESS_CONFIRMATION_REDUCER_KEY } from '@tcp/core/src/constants/reducer.constants';
import { createSelector } from 'reselect';
import EMAIL_CONFIRMATION_CONSTANTS from '../EmailConfirmation.constants';
import {
  getDynamicLabelValues,
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../../../utils/labels/labelUtilty';
import {
  GLOBAL_HELPCENTER_LABELS,
  GlobalHelpCenterLabels,
  lblAccountLockedErrorMsg,
  lblAccountSameEmailError,
  lblEmailVerificationError,
} from '../../../../../../../utils/labels/globalHelpCenter.labels';

export const emailConfirmationRequestLoader = (state) => {
  return state[MERGE_ACCOUNT_EMAIL_ADDRESS_CONFIRMATION_REDUCER_KEY]?.get('isFetching');
};

export const getEmailConfirmationRequestLoader = createSelector(
  emailConfirmationRequestLoader,
  (isFetching) => isFetching
);

export const getEmailConfirmationFailure = (state) => {
  return state[MERGE_ACCOUNT_EMAIL_ADDRESS_CONFIRMATION_REDUCER_KEY]?.get('error');
};

export const getEmailConfirmationSuccess = (state) => {
  return state[MERGE_ACCOUNT_EMAIL_ADDRESS_CONFIRMATION_REDUCER_KEY]?.get(
    'emailConfirmationSuccess'
  );
};

export const getMergeAccountEmailConfirmationSuccess = createSelector(
  getEmailConfirmationSuccess,
  (getEmailConfirmationSuccessData) => getEmailConfirmationSuccessData
);

const errorMessage = (error) => {
  const helpLabels = getLabelFromCopyOrFromTranslation(
    GLOBAL_HELPCENTER_LABELS,
    GlobalHelpCenterLabels
  );
  const defaultError = getDynamicLabelValues('dynamic.error_messages.lbl_errorMessages_DEFAULT');
  if (error?.errorMessage === EMAIL_CONFIRMATION_CONSTANTS.EMAIL_ADDRESS_SAME) {
    return renderLabel(helpLabels[lblAccountSameEmailError], defaultError);
  }
  if (error?.errorCode === EMAIL_CONFIRMATION_CONSTANTS.ACCOUNT_HOLD) {
    return renderLabel(helpLabels[lblAccountLockedErrorMsg], defaultError);
  }
  return error?.errorMessage ? helpLabels[lblEmailVerificationError] : defaultError;
};

export const getMergeAccountEmailConfirmationError = createSelector(
  getEmailConfirmationFailure,
  (error) => (error ? errorMessage(error) : null)
);
